import React from 'react';
import { CWindowWidth } from 'constants/base.const';
import styled from 'styled-components';
import { device, PrimaryColor, menubarBreakPoint } from 'GlobalStyles';

type THeaderWrapperProps = {
  isQuizProcessPageOpened: boolean;
};

export const HeaderHeight = 70;
export const HeaderWrapper = styled.div<THeaderWrapperProps>`
  width: 100%;
  height: ${HeaderHeight}px;
  position: fixed;
  z-index: 50 !important;
  background-color: #ffffff;
  /* ${(props) => (!props.isQuizProcessPageOpened ? 'position: fixed;' : 'position: absolute')} */
  /* ${(props) => (!props.isQuizProcessPageOpened ? 'z-index: 50 !important;' : 'z-index: 0 !important;')} */

  .ant-layout-header {
    background-color: #fff !important;
    height: ${HeaderHeight}px;
    /* line-height: ${HeaderHeight}px; */
    max-width: ${CWindowWidth}px;
    width: 100%;
    ${(props) => (props.isQuizProcessPageOpened ? 'margin: -20px auto;' : 'margin: 0px auto;')} 
    border-bottom: 1px solid #f0f8f6;

    @media screen and ${device.lg} {
      padding: 0 20px;
    }
  }

  .ant-breadcrumb {
    @media screen and ${device.lg} {
      padding: 5px 20px !important;
    }
  }
  .select-component {
    width: 100%;
    color: #000;
  }

  .select-component:hover {
    font-weight: bold;
    color: ${PrimaryColor};
  }

  .ant-menu-submenu {
    font-size: 14px;
    font-weight: 500;
  }

  .ant-menu-submenu .ant-menu-item {
    font-size: 14px;
  }

  .ant-menu-submenu-title {
    padding: 0 10px;
  }

  .ant-menu-horizontal {
    text-align: center;
  }

  .ant-btn {
    margin: 0px 10px;
  }

  .ant-btn > span {
    height: 100%;
  }

  .ant-btn-primary .ant-typography {
    color: #fff;
  }

  .no-cursor {
    cursor: default !important;
  }

  .header-large {
    padding: 0px;
    display: inline-block;

    @media screen and (max-width: ${menubarBreakPoint}px) {
      display: none;
    }
  }

  .header-small {
    display: none;
    text-align: right;

    @media screen and (max-width: ${menubarBreakPoint}px) {
      display: inline-block;
    }
  }

  .logo-image{
    img {
      margin-top: -10px;
    }

    @media screen and ${device.xs} {
      
      img {
        margin-top: -10px;
      }
    }
  }

  .field-menu{
    font-size: 14px;

    @media screen and ${device.xs} {
      font-size: 0.8em;
    }
  }

  .menu-source{
    width:35px;
    height:35px;

    @media screen and ${device.xs} {
      width: 2rem;
      height:2rem;
    }
  }

  /* .field-menu-large{
    @media screen and ${device.xs} {
      display: none;
    }
    
  } */
  .field-menu-small{
    margin-right: 30px;
    
    @media screen and ${device.md} {
      margin-right: 15px;
    }
`;
